<template>
    <rkm-layout-body title="Lista de procedimentos cirúrgicos">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'parametrizacao-procedimento-cirurgico-create' })"
                color="primary"
                authorize="store-parametrizacao-procedimento-cirurgico"
            >
                Cadastrar procedimento cirúrgico
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/parametrizacao/procedimento-cirurgico/List'

export default {
    components: { List },
}
</script>